const keyName = 'dtcqToken';

export function getToken () {
  return localStorage.getItem(keyName);
}

export function setToken (token) {
  return localStorage.setItem(keyName, token);
}

export function removeToken () {
  return localStorage.removeItem(keyName);
}
